import { render, staticRenderFns } from "./ActivosTab.vue?vue&type=template&id=7968d7e0&scoped=true"
import script from "./ActivosTab.vue?vue&type=script&lang=js"
export * from "./ActivosTab.vue?vue&type=script&lang=js"
import style0 from "./ActivosTab.vue?vue&type=style&index=0&id=7968d7e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7968d7e0",
  null
  
)

export default component.exports